const SEAL_ICONS = {
  VERIFIED_PROFILE: 'profile',
  SHOPPED_2_STORES: 'shopped',
  SHOPPED_2_STORES_AND_ONLINE: 'shopped',
  BOUGHT_1_ITEM: 'purchased',
  BOUGHT_4_CATEGORIES: 'purchased',
  BOUGHT_8_CATEGORIES: 'purchased',
  BOUGHT_5_BRANDS: 'purchased',
  BOUGHT_10_BRANDS: 'purchased',
  SOLD_AND_BOUGHT: 'sold',
  SOLD_1_ITEM: 'sold',
  SOLD_5_CATEGORIES: 'sold',
  SOLD_10_BRANDS: 'sold',
  SOLD_20_BRANDS: 'sold',
  SET_UP_INTEREST: 'interests',
  CUSTOMER_5_YEARS: 'loyalty_years',
};

export default (key, isAchieved) => {
  const icon = SEAL_ICONS[key];

  if (!icon) {
    return '';
  }

  return isAchieved ? `${icon}_dark` : icon;
};
